export const helperClearStake = (active: string,
    setante: any,
    setanteHistory: any,
    setAAbonus: any,
    setAAbonusHistory: any,
) => {
    if (active === 'ante') {
        setante('0')
        setanteHistory(['0'])
    } else {
        setAAbonus('AA')
        setAAbonusHistory(['AA'])
    }
}